import React, { useEffect, Suspense } from "react";
import Home from "./components/home/home";
import NotFound from "./components/notfound/notfound";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import Live from "./components/live/live";
import "./firebase/firebase.js";
import dotenv from "dotenv";
var dotenvExpand = require("dotenv-expand");

var myEnv = dotenv.config();
dotenvExpand.expand(myEnv);

function App(props) {
  useEffect(() => {
    props.hideLoader();
  }, [props]);

  return (
    <div className="App">
      <Suspense fallback={null}>
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={Home}></Route>
            <Route exact path="/:AppId" component={Home}></Route>
            <Route exact path="/:AppId/:pageType" component={Home}></Route>
            <Route exact path="/:AppId/:page/:pageID" component={Home}></Route>
            <Route
              exact
              path="/:AppId/:Type/:TypeId/:page/:pageID"
              component={Home}
            ></Route>
            <Route
              exact
              path="/:AppId/:Type/:TypeId/:page/:pageID/:offset"
              component={Home}
            ></Route>

            <Route
              exact
              path="/:AppId/:Type/:page/:pageID"
              component={Home}
            ></Route>

            <Route
              exact
              path="/:AppId/livePage/:Id/watch"
              render={(props) => <Live {...props} menu={"home"} />}
            ></Route>
            <Route path="" component={NotFound} />
          </Switch>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default withRouter(App);
